import { onDocumentReady } from "../utils/dom";
import InitVideoSections from './video';
import initOverlays from './overlay';
import initSlideShow from './slideshow';
import initFeatures from './features';
import initFaq from './faq';
import initModelsSlider from './models-slider'
import initCardSlider from './card-slider'
import initHeaderVideo from './header-video'
import initProductViewer from './fit'
import './styles/index.scss'
import 'swiper/swiper-bundle.min.css';

export function enableOnlyTable(swiper){
  if(window.matchMedia('(max-width: 1140px)').matches){
    swiper.disable();
    swiper.el.classList.add('swiper-non-slider');
  } else {
    swiper.el.classList.remove('swiper-non-slider');
    swiper.enable();
    swiper.update();
  }
}

onDocumentReady(() => {
  initHeaderVideo();
  InitVideoSections();
  initSlideShow();
  initFeatures();
  initOverlays();
  initFaq();
  initModelsSlider();
  initCardSlider();
  initProductViewer();
})